import { appMethod as app } from '@utils/app';

import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';

import { ScrollView } from 'src/jisu-component/scroll-view/ScrollView';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './MyGroup.less';

export default class MyGroup extends OfficialPage {
  state = {
    list: [],
    param: {
      page: 1,
      page_size: 5,
      is_leader_order: 1,
      current_status: 0
    },
    isLeader: 1,
    status: 0,
    noMore: false
  }

  constructor(props) {
    super(props);
    document.title = '我的拼团';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    let _this = this
    app.globalData.myGroupRefresh = false
    _this.getMyGroupBuy()
  }

  componentDidMount() {
    if (app.globalData.myGroupRefresh) {
      this.setData({
        param: {
          page: 1,
          page_size: 5,
          is_leader_order: 1,
          current_status: 0
        }
      })
      this.getMyGroupBuy()
      app.globalData.myGroupRefresh = false
    }
  }

  getMyGroupBuy = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppGroupBuy/MyGroupBuy',
      data: _this.data.param,
      success: function(data) {
        _this.setData({ list: data.data })
      }
    })
  }
  onShareAppMessage = e => {
    let that = this,
      url = '/pages/myGroup/myGroup',
      title = '',
      imageUrl = ''
    if (e.from == 'button') {
      let index = e.target.dataset.index,
        info = this.data.list[index],
        groupInfo = info.form_data.group_buy_order_info,
        teamToken = info.team_token,
        goodsInfo = info.form_data.goods_info[0],
        franchisee =
          info.app_id == app.getAppId()
            ? ''
            : '&franchisee=' + info.app_id
      url =
        '/joinGroupDetail?detail=' +
        groupInfo.goods_id +
        '&teamToken=' +
        teamToken +
        franchisee +
        (app.globalData.pageShareKey
          ? '&psid=' + app.globalData.pageShareKey
          : '')
      title =
        app.getUserInfo('nickname') +
        ' 喊你拼单啦~ ' +
        goodsInfo.price +
        '元拼' +
        goodsInfo.goods_name +
        '，火爆抢购中......'
      imageUrl =
        'https://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/group_goods_share.jpeg'
    }
    return app.shareAppMessage({
      title: title,
      path: url,
      imageUrl: imageUrl,
      success: function(addTime) {
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: { add_time: addTime },
          success: function(res) {
            if (res.status == 0) {
              res.data &&
              that.setData({
                rewardPointObj: {
                  showModal: true,
                  count: res.data,
                  callback: ''
                }
              })
            }
          }
        })
      }
    })
  }
  getGroupOrders = e => {
    this.setData({ isLeader: e.currentTarget.dataset.status })
    this.setData({
      'param.page': 1,
      'param.current_status': 0,
      'param.is_leader_order': e.currentTarget.dataset.status
    })
    this.setData({ status: 0, noMore: false })
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppGroupBuy/MyGroupBuy',
      data: _this.data.param,
      success: function(data) {
        _this.setData({ list: data.data })
      }
    })
  }
  getGroupOrderByStatus = e => {
    this.setData({
      'param.page': 1,
      'param.current_status': e.currentTarget.dataset.status
    })
    this.setData({ status: e.currentTarget.dataset.status })
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppGroupBuy/MyGroupBuy',
      data: _this.data.param,
      success: function(data) {
        _this.setData({ list: data.data })
      }
    })
  }
  turnToDetail = e => {
    let id = e.currentTarget.dataset.orderid
    let franchiseeId = e.currentTarget.dataset.franchisee
    let queryStr =
      franchiseeId === app.getAppId()
        ? ''
        : '&franchisee=' + franchiseeId
    app.turnToPage(
      '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' + id + queryStr
    )
  }
  getMore = e => {
    console.warn('more')
    if (e.target.dataset.page !== this.data.param.page) {
      return
    }
    if (this.data.noMore) {
      return
    }
    let _this = this
    this.data.param.page = e.target.dataset.page + 1
    app.sendRequest({
      url: '/index.php?r=AppGroupBuy/MyGroupBuy',
      data: _this.data.param,
      success: function(data) {
        if (data.is_more == 0) {
          _this.setData({ noMore: true })
        }
        if (data.data.length != 0) {
          let list = _this.data.list.concat(data.data)
          _this.setData({ list: list })
          _this.setData({ 'param.page': _this.data.param.page })
        }
      }
    })
  }
  retrieveMoney = e => {
    let _this = this
    let franchiseeId = e.currentTarget.dataset.franchisee
    franchiseeId = franchiseeId === app.getAppId() ? '' : franchiseeId
    app.sendRequest({
      url: '/index.php?r=AppShop/ComfirmRefund',
      data: {
        order_id: e.target.dataset.id,
        sub_shop_app_id: franchiseeId
      },
      success: function(data) {
        if (data.status === 0) {
          app.showToast({
            title: '确认成功'
          })
          _this.componentWillMount()
        }
      }
    })
  }
  onceMore = e => {
    let id = e.currentTarget.dataset.id
    let franchiseeId = e.currentTarget.dataset.franchisee
    let queryStr =
      franchiseeId === app.getAppId()
        ? ''
        : '&franchisee=' + franchiseeId
    app.turnToPage(
      '/pages/groupGoodsDetail/groupGoodsDetail?detail=' + id + queryStr
    )
  }
  pay = e => {
    let _this = this
    let franchiseeId = e.currentTarget.dataset.franchisee
    franchiseeId = franchiseeId === app.getAppId() ? '' : franchiseeId
    let queryStr = franchiseeId ? '' : '&franchisee=' + franchiseeId
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: e.target.dataset.id,
    //     sub_shop_app_id: franchiseeId
    //   },
    //   success: function(res) {
    //     var param = res.data,
    //       orderId = e.target.dataset.id
    //     param.orderId = orderId
    //     param.goodsType = e.target.dataset.type
    //     param.success = function() {
    //       setTimeout(function() {
    //         app.turnToPage(
    //           '/eCommerce/pages/groupOrderDetail/groupOrderDetail?id=' +
    //           orderId +
    //           queryStr
    //         )
    //       }, 1500)
    //     }
    //     app.wxPay(param)
    //   }
    // })
    app.goPay({
      orderId: e.target.dataset.id,
      franchisee: franchiseeId,
      successUrl: '/groupOrderDetail?id=' + orderId + queryStr
    });
  }
  goToOrderDetail = () => {
    app.turnToPage('/eCommerce/pages/myOrder/myOrder')
  }
  cancelOrder = e => {
    let that = this
    let franchiseeId = e.currentTarget.dataset.franchisee
    franchiseeId = franchiseeId === app.getAppId() ? '' : franchiseeId
    app.showModal({
      content: '是否取消拼团？',
      showCancel: true,
      confirmText: '是',
      cancelText: '否',
      confirm: function() {
        app.sendRequest({
          url: '/index.php?r=AppShop/CancelOrder',
          data: {
            order_id: e.target.dataset.id,
            sub_app_id: franchiseeId
          },
          success: function(res) {
            console.log(res)
            that.componentWillMount()
          }
        })
      }
    })
  }

  render() {
    const {
      isLeader,
      status,
      param,
      list
    } = this.state
    return (
      <div className="official-page my-group">
        <TopNav title="我的拼团"/>
        <div className="wrap">
          <div className="tabs">
            <div
              className={'content ' + (isLeader == 1 ? ' active-tab' : '')}
              data-status="1"
              onClick={this.getGroupOrders}
            >
              我发起的团
            </div>
            <div
              className={'content ' + (isLeader == 0 ? ' active-tab' : '')}
              data-status="0"
              onClick={this.getGroupOrders}
            >
              我参与的团
            </div>
          </div>
          <ScrollView className="sub-tabs" scroll-x="true">
            <div
              className={'status ' + (status == 0 ? ' active-sub-tab' : '')}
              data-status="0"
              onClick={this.getGroupOrderByStatus}
            >
              全部
            </div>
            <div
              className={'status ' + (status == 1 ? ' active-sub-tab' : '')}
              data-status="1"
              hidden={isLeader == 0}
              onClick={this.getGroupOrderByStatus}
            >
              未开团
            </div>
            <div
              className={'status ' + (status == 2 ? ' active-sub-tab' : '')}
              data-status="2"
              onClick={this.getGroupOrderByStatus}
            >
              拼团中
            </div>
            <div
              className={'status ' + (status == 3 ? ' active-sub-tab' : '')}
              data-status="3"
              onClick={this.getGroupOrderByStatus}
            >
              拼团成功
            </div>
            <div
              className={'status ' + (status == 4 ? ' active-sub-tab' : '')}
              data-status="4"
              onClick={this.getGroupOrderByStatus}
            >
              拼团失败
            </div>
            <div
              className={'status ' + (status == 5 ? ' active-sub-tab' : '')}
              data-status="5"
              onClick={this.getGroupOrderByStatus}
            >
              已关闭
            </div>
          </ScrollView>
          <ScrollView
            className="list"
            scroll-y="true"
            data-page={param.page}
            bindscrolltolower={this.getMore}
            enable-back-to-top="true"
          >
            {list.map((item, index) => {
              return (
                <div className="orders" key={index}>
                  <div className="head">
                    <div className="order-time">
                      {'下单时间:' + item.add_time}
                    </div>
                    <div
                      className="order-status"
                      hidden={
                        !(
                          item.form_data.group_buy_order_info.current_status ==
                          1
                        )
                      }
                    >
                      未开团
                    </div>
                    <div
                      className="order-status"
                      hidden={
                        !(
                          item.form_data.group_buy_order_info.current_status ==
                          2
                        )
                      }
                    >
                      拼团中
                    </div>
                    <div
                      className="order-status"
                      hidden={
                        !(
                          item.form_data.group_buy_order_info.current_status ==
                          3
                        )
                      }
                    >
                      拼团成功
                    </div>
                    <div
                      className="order-status"
                      hidden={
                        !(
                          item.form_data.group_buy_order_info.current_status ==
                          4
                        )
                      }
                    >
                      拼团失败
                    </div>
                    <div
                      className="order-status"
                      hidden={
                        !(
                          item.form_data.group_buy_order_info.current_status ==
                          5
                        )
                      }
                    >
                      已关闭
                    </div>
                  </div>
                  <div
                    className="goods-detail"
                    data-orderid={item.order_id}
                    data-franchisee={item.app_id}
                    onClick={this.turnToDetail}
                  >
                    <div className="goods-wrap">
                      <img src={item.form_data.goods_info[0].cover} />
                        <div className="middle">
                          <div className="goods-name">
                            {item.form_data.goods_info[0].goods_name}
                          </div>
                          <div className="goods-spec">
                            {item.form_data.goods_info[0].model_value}
                          </div>
                        </div>
                        <div className="price">
                          <div className="pay-price">
                            {'¥' + item.form_data.goods_info[0].price}
                          </div>
                          <div className="origin-price">
                            {'¥' + item.form_data.original_price}
                          </div>
                          <div className="num">
                            {'x' + item.form_data.goods_info[0].num}
                          </div>
                        </div>
                    </div>
                    <div className="group-info">
                      <div className="info">
                        {'团长昵称：' +
                        item.form_data.group_buy_order_info.leader_username}
                      </div>
                      <div className="info">
                        {'拼团进度：' +
                        item.form_data.group_buy_order_info.max_user_num +
                        '人团|已拼' +
                        item.form_data.group_buy_order_info
                          .current_user_count +
                        '人，还差' +
                        (item.form_data.group_buy_order_info.max_user_num -
                          item.form_data.group_buy_order_info
                            .current_user_count) +
                        '人成团'}
                      </div>
                      <div
                        className={
                          'info ' +
                          (item.form_data.group_buy_order_info.current_status ==
                          1 ||
                          item.form_data.group_buy_order_info.current_status ==
                          5
                            ? 'hide'
                            : '')
                        }
                      >
                        {'结束时间：' +
                        item.form_data.group_buy_order_info.expired_time}
                      </div>
                    </div>
                  </div>
                  <div className="order-info">
                    {'共' + item.form_data.goods_info[0].num + '件商品 合计：¥'}
                    <span style={convertLineStyleData('font-size:30rpx;')}>{item.total_price}</span>
                    {'(含运费¥' + item.express_fee + ')'}
                  </div>
                  <div
                    className="order-btn"
                    hidden={
                      !(item.form_data.group_buy_order_info.current_status == 1)
                    }
                  >
                    <div
                      className="group-btn white"
                      data-id={item.order_id}
                      data-franchisee={item.app_id}
                      onClick={this.cancelOrder}
                    >
                      取消拼团
                    </div>
                    <div
                      className="group-btn red"
                      data-id={item.order_id}
                      data-type={item.goods_type}
                      data-franchisee={item.app_id}
                      onClick={this.pay}
                    >
                      立即支付
                    </div>
                  </div>
                  <div
                    className="order-btn"
                    hidden={
                      !(item.form_data.group_buy_order_info.current_status == 2)
                    }
                  >
                    <button
                      openType="share"
                      className="group-btn red"
                      data-detail={item.form_data.goods_info[0].goods_id}
                      data-franchisee={item.app_id}
                      data-index={index}
                      onClick={this.shareClickEvent}
                    >
                      分享
                    </button>
                  </div>
                  <div
                    className="order-btn"
                    hidden={
                      !(item.form_data.group_buy_order_info.current_status == 3)
                    }
                  >
                    <div
                      className="group-btn white"
                      data-franchisee={item.app_id}
                      onClick={this.goToOrderDetail}
                    >
                      查看订单
                    </div>
                    <div
                      className="group-btn yellow"
                      data-id={item.form_data.goods_info[0].goods_id}
                      data-franchisee={item.app_id}
                      onClick={this.onceMore}
                    >
                      再拼一次
                    </div>
                  </div>
                  <div
                    className="order-btn"
                    hidden={
                      !(item.form_data.group_buy_order_info.current_status == 4)
                    }
                  >
                    <div
                      className="group-btn white"
                      data-id={item.order_id}
                      data-franchisee={item.app_id}
                      onClick={this.retrieveMoney}
                    >
                      已收到退款
                    </div>
                    <div
                      className="group-btn yellow"
                      data-id={item.form_data.goods_info[0].goods_id}
                      data-franchisee={item.app_id}
                      onClick={this.onceMore}
                    >
                      再拼一次
                    </div>
                  </div>
                  <div
                    className="order-btn"
                    hidden={
                      !(item.form_data.group_buy_order_info.current_status == 5)
                    }
                  >
                    <div
                      className="group-btn yellow"
                      data-id={item.form_data.goods_info[0].goods_id}
                      data-franchisee={item.app_id}
                      onClick={this.onceMore}
                    >
                      再拼一次
                    </div>
                  </div>
                </div>
            )
            })}
              <div className="no-more">没有更多数据了~</div>
            </ScrollView>
          </div>
        </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/my-group/MyGroup.jsx